import React from 'react'
import "../recommendedVideos.css"
import VideoCard from './VideoCard'
function RecommendedVideos() {
  return (
    <div className='recommendedVideos'>
      <h1>Recommended</h1>
      <div className='recomended_videos'>
        <VideoCard 
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
        <VideoCard
          title={"Become a web Developer in 10 minutes | 2019/2020"}
          views="35,467 Views"
          channel="Traversy Media"
          timestamp="3 days ago"
          image="https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200214165928/Web-Development-Course-Thumbnail.jpg"
          channelImage="https://res.cloudinary.com/practicaldev/image/fetch/s--59psmm_e--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/62tymo1zomi4qdfjgrge.jpg"
        />
      </div>
    </div>
  )
}

export default RecommendedVideos
